import { BrowserRouter, Switch, Route } from "react-router-dom";
import Home from "./Components/Home";
import LocationContainer from "./Components/LocationContainer";
import CitiesContainer from "./Components/CitiesContainer";
import LocationContextProvider from "./Components/LocationContextProvider";

const App = () => {
	return (
		<LocationContextProvider>
			<BrowserRouter>
				<Switch>
					<Route exact path="/top-cities">
						<CitiesContainer />
					</Route>
					<Route exact path="/">
						<Home />
					</Route>
					<Route exact path="/:locationID">
						<LocationContainer />
					</Route>
				</Switch>
			</BrowserRouter>
		</LocationContextProvider>
	);
};

export default App;
